import { Controller } from "@hotwired/stimulus"

// Lightweight controller for document DNA checkbox updates
// Shows a spinner while the update is in progress
export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    this.minDisplayTime = 150 // Minimum time to show spinner (in ms)
    this.startTime = null
  }

  // Called when turbo form submission starts
  handleSubmitStart() {
    if (this.hasSpinnerTarget) {
      this.startTime = Date.now()
      this.spinnerTarget.style.display = 'inline-block'
    }
    this.setDataSaving(true)
  }

  // Called when turbo form submission ends (success or error)
  handleSubmitEnd() {
    if (this.hasSpinnerTarget && this.startTime) {
      const elapsedTime = Date.now() - this.startTime
      const remainingTime = Math.max(0, this.minDisplayTime - elapsedTime)

      setTimeout(() => {
        this.spinnerTarget.style.display = 'none'
        this.startTime = null
        this.setDataSaving(false)
      }, remainingTime)
    } else {
      this.setDataSaving(false)
    }
  }

  setDataSaving(isSaving) {
    // Find the parent document card and set data-saving attribute
    const documentCard = this.element.closest('.document-item')
    if (documentCard) {
      if (isSaving) {
        documentCard.setAttribute('data-saving', 'true')
      } else {
        documentCard.removeAttribute('data-saving')
      }
    }
  }
}
